// extracted by mini-css-extract-plugin
export default {"root":"EmptyCart-root_Il9Xl"};